import React from 'react';
import AdminLayout from '../components/AdminLayout';

const AdminPlaceholderPage = ({ title, icon: Icon, description }) => {
  return (
    <AdminLayout title={title}>
      <div className="admin-panel-card">
        <div className="admin-placeholder">
          <Icon />
          <h3>{title} bölümü yakında</h3>
          <p>{description}</p>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminPlaceholderPage;
